import { Api6NodeHeaders } from 'api/createApiNodeHeaders'
import { fetchApi } from 'api/fetchApi'
import { paths } from 'api/generated/mailru'

type Get = paths['/mailru/check_current_user']['get']
type Response = Get['responses']['200']['schema']

export const isAuthorizationMailruApi = (headers?: Api6NodeHeaders) =>
  fetchApi<Response>('/mailru/check_current_user', { headers })
